import React from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText, Collapse, Divider } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ArticleIcon from '@mui/icons-material/Article';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';
import FeedIcon from '@mui/icons-material/Feed';
import CommentIcon from '@mui/icons-material/Comment';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import RateReviewIcon from '@mui/icons-material/RateReview';
import InfoIcon from '@mui/icons-material/Info';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import { useHistory } from 'react-router-dom';

const AbstractNav = ({ permissions, currentPath, openAbstractMenu, handleClickAbstractMenu, openAbstractArticle, handleClickAbstractArticle, openAbstractSubMenu, handleClickAbstractSubMenu }) => {
  const history = useHistory();

  const abstractMenuItems = [
    { permission: 'p_abstract-article-approve-create', path: '/admin/abstract/add-approve-article', label: 'Add New', icon: <FactCheckIcon sx={{ color: '#1976d2' }}/> },
    { permission: 'p_abstract-article-approve-list', path: '/admin/abstract/approve-article', label: 'Approved List', icon: <FactCheckIcon sx={{ color: '#1976d2' }}/> },
    { permission: 'p_abstract-article-pending-list', path: '/admin/abstract/pending-article', label: 'Pending List', icon: <PendingActionsIcon sx={{ color: '#1976d2' }}/> },
    { permission: 'p_abstract-article-reject-list', path: '/admin/abstract/reject-article', label: 'Reject List', icon: <SwipeLeftIcon sx={{ color: '#1976d2' }}/> },
    { permission: 'p_abstract-article-categoy-list', path: '/admin/abstract/all-category', label: 'Abstract Category', icon: <FeedIcon sx={{ color: '#1976d2' }}/> },
    { permission: 'p_abstract-article-categoy-list', path: '/admin/abstract/submission', label: 'Submission Type', icon: <FeedIcon sx={{ color: '#1976d2' }}/> },
    { permission: 'p_abstract-article-comments-list', path: '/admin/comments/comments', label: 'Comments', icon: <CommentIcon sx={{ color: '#1976d2' }}/> },
    { permission: 'p_abstract-article-requirements-list', path: '/admin/requirements/requirements', label: 'Requirements', icon: <FolderSharedIcon sx={{ color: '#1976d2' }}/> },
    { permission: 'p_abstract-article-reviewer-list', path: '/admin/reviewer/reviewer-list', label: 'Reviewer', icon: <RateReviewIcon sx={{ color: '#1976d2' }}/> },
    { permission: 'p_abstract-article-author-list', path: '/admin/author/author-list', label: 'Authors', icon: <SupervisedUserCircleIcon sx={{ color: '#1976d2' }}/> },
  ];

  return (
    <div>
      {currentPath !== '/admin/events' && (
        <>
          <Divider sx={{ my: 1 }} />
          <ListItemButton onClick={handleClickAbstractMenu} sx={{ color: '#1976d2' }}>
            <ListItemIcon sx={{ color: '#1976d2' }}>
              <DashboardIcon onClick={() => history.push('/admin/abstract/dashbord')} />
            </ListItemIcon>
            <ListItemText primary="Abstract MS" sx={{ color: '#1976d2' }} />
            {openAbstractMenu ? <ExpandLess /> : <ExpandMore sx={{ color: '#1976d2' }} />}
          </ListItemButton>
        </>
      )}
      <Collapse in={openAbstractMenu} timeout="auto" unmountOnExit>
        {currentPath !== '/admin/events' && (
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/abstract/dashbord')}>
              <ListItemIcon sx={{ color: '#1976d2' }}>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Abstract Dashboard" />
            </ListItemButton>
            <Divider sx={{ my: 1 }} />
            <Divider sx={{ my: 1 }} />
            <ListItemButton onClick={handleClickAbstractArticle} sx={{ color: '#1976d2', pl: 3 }}>
              <ListItemIcon sx={{ color: '#1976d2' }}>
                <ArticleIcon />
              </ListItemIcon>
              <ListItemText primary="Abstracts" />
              {openAbstractArticle ? <ExpandLess /> : <ExpandMore sx={{ color: '#1976d2' }} />}
            </ListItemButton>
            <Collapse in={openAbstractArticle} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {abstractMenuItems.map((menuItem) => {
                  if (permissions[menuItem.permission]) {
                    return (
                      <ListItemButton key={menuItem.path} sx={{ pl: 4 }} onClick={() => history.push(menuItem.path)}>
                        <ListItemIcon>{menuItem.icon}</ListItemIcon>
                        <ListItemText primary={menuItem.label} />
                      </ListItemButton>
                    );
                  }
                  return null;
                })}
                <Divider sx={{ my: 1 }} />
              </List>
            </Collapse>
            <Divider sx={{ my: 1 }} />

          </List>
        )}
        {currentPath !== '/admin/events' && (
          <ListItemButton onClick={handleClickAbstractSubMenu} sx={{ color: '#1976d2', pl: 3 }}>
            <ListItemIcon sx={{ color: '#1976d2' }}>
              <AppSettingsAltIcon />
            </ListItemIcon>
            <ListItemText primary="Setting" sx={{ color: '#1976d2' ,}} />
            {openAbstractSubMenu ? <ExpandLess /> : <ExpandMore sx={{ color: '#1976d2' }} />}
          </ListItemButton>
        )}
        <Collapse in={openAbstractSubMenu} timeout="auto" unmountOnExit>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon sx={{ color: '#1976d2' }}>
              <ContactPageIcon onClick={() => history.push('/admin/profile/profile')} />
            </ListItemIcon>
            <ListItemText primary="Profile" onClick={() => history.push('/admin/profile/profile')} />
          </ListItemButton>
          {permissions['p_abstract-add-questions'] === true && (
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon sx={{ color: '#1976d2' }}>
                <ContactPageIcon />
              </ListItemIcon>
              <ListItemText primary="Abstract Score" onClick={() => history.push('/admin/questions/answers')} />
            </ListItemButton>
          )}
          {permissions['p_event-email-template'] === true && (
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon sx={{ color: '#1976d2' }}>
                <InfoIcon onClick={() => history.push('/admin/abstract/index-template')} />
              </ListItemIcon>
              <ListItemText primary="Email Template" onClick={() => history.push('/admin/abstract/index-template')} />
            </ListItemButton>
          )}
        </Collapse>
      </Collapse>

    </div>
  );
};

export default AbstractNav;